import { useEffect, useRef } from "react";

/**
 * A custom React hook that provides a function to introduce a delay before resolving a Promise.
 * @returns {Object} - An object containing the `delay` function.
 */
const useDelay = () => {
  const timeoutRef = useRef();

  /**
   * Cleanup function to clear the timeout when the component unmounts.
   */
  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  /**
   * Function to introduce a delay before resolving a Promise.
   * @param {number} ms - The delay time in milliseconds.
   * @returns {Promise<void>} - A Promise that resolves after the specified delay.
   */
  const delay = ms =>
    new Promise(resolve => {
      timeoutRef.current = setTimeout(() => {
        resolve();
      }, ms);
    });

  return { delay };
};

export default useDelay;
